import { formatMoney } from '../../../../utils/helpers';

export type NetCash = {
  label: string;
  amount: string;
  color: 'grayLight' | 'leaseEndGreen' | 'leaseEndRed';
};

export type NetCashOutcome = 'positive' | 'negative' | 'breakEven';

export const getNetCashOutcome = (offerAmount: number, payoffAmount: number): NetCashOutcome => {
  const net = offerAmount - payoffAmount;
  if (net === 0) return 'breakEven';
  return net > 0 ? 'positive' : 'negative';
};

export const getNetCashAmount = (offerAmount: number, payoffAmount: number): string =>
  formatMoney(Math.abs(offerAmount - payoffAmount), { noCents: true });

export const SETTLEMENT_FINE_PRINT =
  'The final amount, including payoff, taxes, and offer, is settled around signing.';

export const getNetCash = (offerAmount: number, payoffAmount: number): NetCash => {
  const outcome = getNetCashOutcome(offerAmount, payoffAmount);

  if (outcome === 'breakEven') {
    return { label: "You're right at your payoff", amount: '~$0', color: 'grayLight' };
  }

  const amount = `~${getNetCashAmount(offerAmount, payoffAmount)}`;
  return outcome === 'positive'
    ? { label: "You'd get", amount, color: 'leaseEndGreen' }
    : { label: "You'd pay", amount, color: 'leaseEndRed' };
};
